/**
 * Builds the display-only house number extension by concatenating the raw BAG
 * fields letter + addition (e.g. "B" + "1" -> "B1"). Used for the UI (dropdown
 * options, formatted address) and the confirmation overview — never for outgoing
 * payloads, which send house_number_letter and house_number_addition separately.
 */
export function formatHouseNumberExtension(address: {
  house_number_letter?: string | null;
  house_number_addition?: string | null;
}): string {
  return `${address.house_number_letter ?? ''}${address.house_number_addition ?? ''}`;
}
